import { render } from "./CartItemsList.vue?vue&type=template&id=3046424a&scoped=true"
import script from "./CartItemsList.vue?vue&type=script&lang=js"
export * from "./CartItemsList.vue?vue&type=script&lang=js"

import "./CartItemsList.vue?vue&type=style&index=0&id=3046424a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3046424a"]])

export default __exports__